export default function () {
    return {
        init() {
            window.addEventListener('resize', () => {
                this.setWidth()
            });
            this.setWidth();
        },
        setWidth() {
            const x = this.$el.offsetLeft;
            const target = document.documentElement.offsetWidth;
            this.$el.style.width = `${target - x}px`
        }
    }
}